import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './translations/en.json';
import no from './translations/no.json';

export const STORE_LANGUAGE_KEY = "kosiband.settings.lang";

const languageDetectorPlugin = {
	type: "languageDetector",
	async: true,
	init: () => { },
	detect: async function (callback: (lang: string) => void) {
		try {
			const storageLng = localStorage.getItem(STORE_LANGUAGE_KEY);
			if (storageLng) {
					return callback(storageLng);
			} else {
				return 'no';
				// return callback(deviceLanguage.split("_")[0] && deviceLanguage.split("_")[0]);
			}

		} catch (error) {
			console.log("Error reading language", error);
		}
	},
	cacheUserLanguage: async function (language: string) {
		try {
			console.log("Storing language: ", language);
			localStorage.setItem(STORE_LANGUAGE_KEY, language);
			// await AsyncStorage.setItem(STORE_LANGUAGE_KEY, language);
		} catch (error) { }
	},
};

const resources = {
	en: {
		translation: en,
	},
	no: {
		translation: no,
	},
};

i18n.use(initReactI18next).init({
	resources,
	compatibilityJSON: 'v3',
	fallbackLng: 'no',
	// fallbackLng: deviceLanguage.split("_")[0] && deviceLanguage.split("_")[0],
	interpolation: {
		escapeValue: false,
	},
	detection: {
		order: ['localStorage', 'navigator'],
		caches: ['localStorage'],
	},
})
	.then((r: any) => console.log("i18n initialized: ", r))
	.catch((error) => {
		console.error('Error initializing i18n:', error);
	});

export default i18n;